<template>
  <v-container fluid>
    <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
      <v-col cols="12" md="4">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">Contatos</div>
              <div class="text text--thin mb-2">Realizar novo cadastro de contatos</div>
              <v-btn @click="dialog = true" color="primary" class="mt-1"><v-icon class="mr-1">contact_phone</v-icon>Novo contato</v-btn>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>add</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" class="text-md-right text-center" v-if="$root.Permissions.integrator()">
        <v-btn @click="dialogImport = true" color="primary" class="mt-1"><v-icon class="mr-1">file_upload</v-icon>Importar contatos</v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="dados"
      disable-sort
      :server-items-length="total"
      :options.sync="options"
      :search="search"
      loading-text="Carregando... Por favor aguarde"
      :loading="carregando"
      class="elevation-1 base_table mt-4"
      :footer-props="{
        itemsPerPageOptions: [5,10,15,20,25,50,100],
        showFirstLastPage: true,
        firstIcon: 'skip_previous',
        lastIcon: 'skip_next',
        prevIcon: 'chevron_left',
        nextIcon: 'chevron_right'
      }"
      :header-props="{
        sortIcon: 'north',
      }"
    >
      <template v-slot:top>
        <v-row no-gutters align="center" justify="space-between">
          <v-row no-gutters>
            <div class="py-2 px-2">
              <v-form @submit.prevent="applyFilter()">
                <v-text-field
                  clearable
                  hide-details=""
                  clear-icon="close"
                  v-model="search"
                  outlined
                  label="Busca"
                  @click:clear="limparBusca()"
                ></v-text-field>
              </v-form>
            </div>
            <div class="py-2 px-2" v-if="$root.Permissions.admin()">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="distribuidor"
                :items="distribuidores"
                hide-details=""
                clearable
                clear-icon="close"
                label="Distribuidor"
                append-icon="expand_more"
                outlined
                @change="applyFilter()"
                @click:clear="applyFilter()"
              >
              </v-autocomplete>
            </div>
            <div class="py-2 px-2" v-if="!$root.Permissions.integrator()">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="integrador"
                :items="integradores"
                hide-details=""
                clearable
                clear-icon="close"
                label="Integrador"
                append-icon="expand_more"
                outlined
                @change="applyFilter()"
                @click:clear="applyFilter()"
              >
              </v-autocomplete>
            </div>
            <div class="py-2 px-2" v-if="!$root.Permissions.revendor() && !$root.Permissions.integrator()">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="revendedor"
                :items="revendedores"
                hide-details=""
                clearable
                clear-icon="close"
                label="Revendedor"
                append-icon="expand_more"
                outlined
                @change="applyFilter()"
                @click:clear="applyFilter()"
              >
              </v-autocomplete>
            </div>
            <div class="py-2 px-2">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                :items="estados"
                label="Estado"
                append-icon="expand_more"
                v-model="estado"
                hide-details=""
                :loading="carregando || loadingEstados"
                :disabled="carregando || loadingEstados"
                outlined
                @click:clear="() => {
                  this.options.page = 1
                  this.applyFilter()
                }"
                clearable
                clear-icon="close"
                @change="filterCidade()"
              ></v-autocomplete>
            </div>
            <div class="py-2 px-2">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                :items="cidadesFiltro"
                label="Cidade"
                append-icon="expand_more"
                v-model="cidade"
                hide-details=""
                :loading="carregando || loadingCidades"
                :disabled="carregando || loadingCidades"
                outlined
                @click:clear="() => {
                  this.options.page = 1
                  this.applyFilter()
                }"
                clearable
                clear-icon="close"
                @change="applyFilter()"
              ></v-autocomplete>
            </div>
          </v-row>
          <div>
            <v-menu
              bottom
              center
              offset-y
              max-height="400"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  Exportar
                  <v-icon>arrow_drop_down</v-icon>
                </div>
              </template>
              <v-list>
                <v-list-item @click="exportXls()">
                  <v-list-item-icon class="mr-1">
                    <v-icon color="primary">receipt_long</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Exportar para XLS</v-list-item-title>
                </v-list-item>
                <v-list-item @click="exportPdf()">
                  <v-list-item-icon class="mr-1">
                    <v-icon color="primary">picture_as_pdf</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Exportar / Imprimir PDF</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-row>
      </template>
      <template v-slot:item.cli_tipo="{ item }">
          <div v-if="item.cli_tipo === 1">Pessoa Física</div>
          <div v-else-if="item.cli_tipo === 2">Pessoa Jurídica</div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row no-gutters align="center" justify="center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="goToContact(item)" color="primary" class="mr-2">
                visibility
              </v-icon>
            </template>
            <span>Detalhes</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="openContato(item)" color="primary" class="mr-2">
                edit
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                delete
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </v-row>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{contato.uuid_cli_id ? 'Editar' : 'Novo'}}  cliente
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formContato">
          <v-row>
            <v-col v-if="$root.Permissions.admin()" cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="contato.uuid_dis_id"
                :items="distribuidores"
                clearable
                clear-icon="close"
                label="Distribuidor"
                append-icon="expand_more"
                @change="getIntegrators(contato.uuid_dis_id, true)"
                :loading="salvando"
                :disabled="salvando"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col v-if="!$root.Permissions.integrator()" cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="contato.uuid_int_id"
                :items="integradoresCadastro"
                clearable
                clear-icon="close"
                label="Integrador"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
                :rules="[rules.required]"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-text-field
                autofocus
                v-model="contato.cli_nome"
                label="Nome*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-autocomplete
                v-model="contato.cli_tipo"
                autocomplete="off"
                :items="tipos"
                :loading="salvando"
                :disabled="salvando"
                :rules="[rules.required]"
                append-icon="expand_more"
                label="Tipo*"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field-cpf
                v-if="contato.cli_tipo == 1"
                v-model="contato.cli_cpf"
                label="CPF*"
                v-bind:properties="{
                  readonly: false,
                  disabled: salvando,
                  outlined: true,
                  clearable: true,
                  placeholder: '',
                  loading: salvando
                }"
                v-bind:options="{
                  outputMask: '###.###.###-##',
                  empty: null,
                  applyAfter: false,
                }"
              />
              <v-text-field-cnpj
                v-if="contato.cli_tipo == 2"
                v-model="contato.cli_cnpj"
                label="CNPJ*"
                v-bind:properties="{
                  readonly: false,
                  disabled: salvando,
                  outlined: true,
                  clearable: true,
                  placeholder: '',
                  loading: salvando
                }"
                v-bind:options="{
                  outputMask: '###.###.###/####-##',
                  empty: null,
                  applyAfter: false,
                }"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field-simplemask
                v-model="contato.cli_telefone"
                v-bind:label="'Telefone'"
                :loading="salvando"
                :disabled="salvando"
                v-bind:properties="{
                  disabled: false,
                  outlined: true,
                  clearable: true,
                  placeholder: '',
                }"
                v-bind:options="{
                  inputMask: '(##) #####-####',
                  outputMask: '(##) #####-####',
                  empty: null,
                  applyAfter: false,
                }"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field-simplemask
                v-model="contato.cli_celular"
                v-bind:label="'Celular*'"
                :rules="[rules.required]"
                :loading="salvando"
                :disabled="salvando"
                v-bind:properties="{
                  disabled: false,
                  outlined: true,
                  clearable: true,
                  placeholder: '',
                }"
                v-bind:options="{
                  inputMask: '(##) #####-####',
                  outputMask: '(##) #####-####',
                  empty: null,
                  applyAfter: false,
                }"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="contato.cli_email"
                label="E-mail*"
                :rules="[rules.required, rules.email]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-menu
                ref="calendarData"
                v-model="calendarData"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Data de nascimento*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatada"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarData = false
                      contato.cli_nascimento = $root.Formatter.parseDate(dataFormatada)
                      updatePickerModalData = $root.Formatter.parseDate(dataFormatada)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalData"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="data"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" class="pb-0 pt-0">
              <v-textarea
                outlined
                no-resize
                :loading="salvando"
                :disabled="salvando"
                rows="3"
                v-model="contato.cli_detalhes"
                label="Detalhes do contato"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field-cep
                v-model="contato.cli_cep"
                label="CEP*"
                :rules="[rules.required]"
                @change="searchCep(contato.cli_cep)"
                v-bind:properties="{
                  loading: loadingCep || salvando,
                  disabled: loadingCep || salvando,
                  outlined: true,
                  clearable: true,
                  placeholder: '',
                }"
                v-bind:options="{
                  outputMask: '########',
                  empty: null,
                  applyAfter: false,
                }"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-autocomplete
                v-model="contato.cli_uf"
                autocomplete="off"
                :items="estados"
                :rules="[rules.required]"
                :loading="salvando || loadingEstados || loadingCep"
                :disabled="salvando || loadingEstados || loadingCep"
                label="Estado*"
                append-icon="expand_more"
                outlined
                @change="filterCidade(contato.cli_uf)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-autocomplete
                autocomplete="off"
                v-model="contato.cli_cidade"
                :items="cidadesFiltradas"
                :loading="salvando || loadingCidades || loadingCep"
                :disabled="salvando || loadingCidades || loadingCep"
                label="Cidade*"
                :rules="[rules.required]"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="contato.cli_bairro"
                outlined
                :rules="[rules.required]"
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Bairro*"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="9" lg="9" xl="9" class="pb-0 pt-0">
              <v-text-field
                v-model="contato.cli_rua"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                :rules="[rules.required]"
                label="Rua*"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
              <v-text-field
                v-model="contato.cli_numero"
                outlined
                :loading="salvando || loadingCep"
                :rules="[rules.required]"
                :disabled="salvando || loadingCep"
                label="Número*"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-text-field
                v-model="contato.cli_complemento"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Complemento"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditContato()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Contato
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDelete = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover este contato?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDelete = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeContato()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogImport"
      persistent
      max-width="850px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Importar contatos
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogImport = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-row align="center">
          <v-col cols="12" sm="7" md="7" lg="7" xl="7">
            <div class="text">
              Aqui você consegue cadastrar vários contatos de uma vez. <br>
              Para realizar este cadastro em lote, você vai precisar preencher uma planilha modelo do StartIn com os contatos que deseja cadastrar.
              <br>
              <br>
              Clique no botão abaixo para fazer o download da planilha modelo.
              <br>
              <a :href="`${API_URL_FILE}contatos.csv`" target="_blank">
                <v-btn color="primary" class="mt-2 mb-3">
                  <v-icon class="mr-1">import_export</v-icon>
                  Download planilha modelo
                </v-btn>
              </a>
            </div>
          </v-col>
          <v-col cols="12" sm="5" md="5" lg="5" xl="5">
            <v-form ref="formImportar">
              <div class="text text--thin mb-2">
                Selecione o arquivo em excel com os contatos
              </div>
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="contato_importar"
                prepend-icon="description"
                label="Arquivo*"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                :rules="[rules.required, rules.size]"
                hint="Tamanho máximo permitido: 10MB"
                persistent-hint
                outlined
              ></v-file-input>
            </v-form>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogImport = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="importaContatos()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api, { API_URL_FILE } from '@API'
import axios from 'axios'
import moment from 'moment'
export default {
  data () {
    return {
      API_URL_FILE,
      dialogImport: false,
      search: '',
      total: 0,
      options: {},
      carregando: true,
      dialog: false,
      dialogDelete: false,
      salvando: false,
      tipos: [
        {
          text: 'Pessoa Física',
          value: 1
        },
        {
          text: 'Pessoa Jurídica',
          value: 2
        }
      ],
      tipo: {},
      acessos: [],
      dialogExport: false,
      loadingCep: false,
      loadingEstados: false,
      loadingCidades: false,
      estados: [],
      cidades: [],
      cidadesFiltradas: [],
      cidadesFiltro: [],
      cidade: null,
      estado: null,
      importacao: '',
      rules: {
        required: value => !!value || 'Obrigatório.',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'E-mail inválido.'
        }
      },
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'cli_id'
        },
        { text: 'Nome', value: 'cli_nome' },
        { text: 'Tipo', value: 'cli_tipo' },
        { text: 'E-mail', value: 'cli_email' },
        { text: 'Cidade', value: 'cli_cidade' },
        { text: 'Celular', value: 'cli_celular' },
        { text: 'Integrador / Distribuidor', value: 'int_dis_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 130
        }
      ],
      headerXls: [
        { text: 'Nome', value: 'cli_nome' },
        { text: 'Tipo', value: 'cli_tipo' },
        { text: 'Telefone', value: 'cli_telefone' },
        { text: 'Celular', value: 'cli_celular' },
        { text: 'E-mail', value: 'cli_email' },
        { text: 'Detalhes', value: 'cli_detalhes' },
        { text: 'CPF', value: 'cli_cpf' },
        { text: 'CNPJ', value: 'cli_cnpj' },
        { text: 'Nascimento', value: 'cli_nascimento' },
        { text: 'UF', value: 'cli_uf' },
        { text: 'Cidade', value: 'cli_cidade' },
        { text: 'Bairro', value: 'cli_bairro' },
        { text: 'Rua', value: 'cli_rua' },
        { text: 'Número', value: 'cli_numero' },
        { text: 'Complemento', value: 'cli_complemento' },
        { text: 'Integrador', value: 'int_dis_nome' }
      ],
      headerExport: [
        { text: 'Nome', value: 'cli_nome' },
        { text: 'Telefone', value: 'cli_telefone' },
        { text: 'Celular', value: 'cli_celular' },
        { text: 'E-mail', value: 'cli_email' },
        { text: 'Tipo', value: 'cli_tipo' },
        { text: 'Documento', value: 'cli_doc' },
        { text: 'UF', value: 'cli_uf' },
        { text: 'Cidade', value: 'cli_cidade' },
        { text: 'Integrador', value: 'int_dis_nome' }
      ],
      dados: [],
      distribuidores: [],
      distribuidor: null,
      revendedores: [],
      revendedor: null,
      integradores: [],
      integrador: null,
      contato: {
        cli_nome: '',
        cli_tipo: 1,
        cli_cpf: '',
        cli_cnpj: '',
        cli_nascimento: '',
        cli_telefone: '',
        cli_celular: '',
        cli_email: '',
        cli_detalhes: '',
        cli_cep: '',
        cli_uf: '',
        cli_cidade: '',
        cli_bairro: '',
        cli_rua: '',
        cli_numero: '',
        cli_complemento: '',
        uuid_int_id: null,
        uuid_dis_id: null
      },
      data: '',
      dataFormatada: '',
      updatePickerModalData: '',
      calendarData: false,
      dialogImportacao: false,
      loadingXls: false,
      loadingPdf: false,
      distribuidorAnterior: null,
      integradoresCadastro: [],
      revendedoresCadastro: [],
      contato_importar: null,
      dadosExport: [],
      headersExport: []
    }
  },
  watch: {
    data () {
      this.dataFormatada = moment(this.data).format('L')
      this.contato.cli_nascimento = this.$root.Formatter.parseDate(this.dataFormatada)
      this.calendarData = false
    },
    options: {
      handler () {
        this.getContatos()
      },
      deep: true
    }
  },
  methods: {
    async exportPdf () {
      let url = 'clientes?'
      if (this.search) url += `&busca=${this.search}`
      if (this.distribuidor) url += '&distribuidor=' + this.distribuidor
      if (this.integrador) url += '&integrador=' + this.integrador
      if (this.revendedor) url += '&revendedor=' + this.revendedor
      if (this.estado) url += '&estado=' + this.estado
      if (this.cidade) url += '&cidade=' + this.cidade

      this.$root.Export.PDF(this, {
        titulo: 'Lista de contatos',
        landscape: true,
        formatar: this.ajustaDadosParaPDF,
        tabela: {
          headers: this.headerExport,
          url
        }
      })
    },
    ajustaDadosParaPDF (dados) {
      dados.map(item => {
        let tipo = this.tipos[item.cli_tipo - 1]
        if (item.cli_tipo === 1) {
          item.cli_doc = item.cli_cpf
        }
        if (item.cli_tipo === 2) {
          item.cli_doc = item.cli_cnpj
        }
        item.cli_tipo = tipo.text
      })
      return dados
    },
    async importaContatos () {
      this.salvando = true
      const formData = new FormData()
      formData.append(`type`, 'contatos')
      formData.append(`file`, this.contato_importar)

      await Api.post('dados/importar', formData)
        .then(res => {
          this.salvando = false
          this.dialogImport = false
          let info = res.data.info
          if (info['cliente-existente'] === 0) {
            this.$root.SnackControl.open(this, {
              text: 'Contatos cadastrados com sucesso!',
              color: 'success'
            })
          } else {
            let text = ''
            if (info['cliente-existente-email'] > 0) {
              text += `Contatos com e-mail já existente: ${info['cliente-existente-email']}<br>`
            }
            if (info['cliente-existente-cpf'] > 0) {
              text += `Contatos com CPF já existente: ${info['cliente-existente-cpf']}<br>`
            }
            if (info['cliente-existente-cnpj'] > 0) {
              text += `Contatos com CNPJ já existente: ${info['cliente-existente-cnpj']}`
            }
            this.$root.SnackControl.open(this, {
              text: `<b>Alguns contatos não puderam ser cadastrados!</b>`,
              lead: text,
              multiline: true,
              time: 15000,
              color: 'warning'
            })
          }
          this.getContatos()
        })
        .catch(err => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao cadastrar os contatos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeHeader () {
      if (this.$root.Permissions.distributor() !== null) {
        this.headers[6].text = 'Integrador'
        this.headerXls[15].text = 'Integrador'
      } else if (!this.$root.Permissions.admin()) {
        delete this.headers[6]
        delete this.headerXls[15]
      }
    },
    limparBusca () {
      this.search = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      this.carregando = true

      let query = Object.assign({},
        this.search ? { busca: this.search } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.revendedor ? { revendedor: this.revendedor } : '',
        this.estado ? { estado: this.estado } : '',
        this.cidade ? { cidade: this.cidade } : ''
      )

      this.$router.replace({name: this.$route.name, query: query}).catch(() => {})
      this.options.page = 1
      this.distribuidorAnterior = this.distribuidor
      this.getIntegrators(this.distribuidor)
      this.getRevendedores(this.distribuidor)
      this.getContatos()
    },
    async getContatos () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 1
      let endpoint = ''

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage
      if (this.search) endpoint += `&busca=${this.search}`
      if (this.distribuidor) endpoint += '&distribuidor=' + this.distribuidor
      if (this.integrador) endpoint += '&integrador=' + this.integrador
      if (this.revendedor) endpoint += '&revendedor=' + this.revendedor
      if (this.estado) endpoint += '&estado=' + this.estado
      if (this.cidade) endpoint += '&cidade=' + this.cidade

      await Api.get(`clientes?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          if (res.data) {
            let info = []
            if (res.data.data.length > 0) {
              res.data.data.map(item => {
                info.push({
                  cli_id: item.cli_id,
                  uuid_cli_id: item.uuid_cli_id,
                  cli_nome: item.cli_nome,
                  cli_tipo: item.cli_tipo,
                  cli_telefone: item.cli_telefone,
                  cli_celular: item.cli_celular,
                  cli_email: item.cli_email,
                  cli_cidade: item.cli_cidade,
                  cli_uf: item.cli_uf,
                  cli_cpf: item.cli_cpf,
                  cli_cnpj: item.cli_cnpj,
                  int_dis_nome: item.integrador === null ? 'Não possui' : item.integrador.int_nome
                })
              })
            }
            this.total = res.data.total
            this.dados = info
          }
          this.carregando = false
        })
        .catch(err => {
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os contatos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    getDistributors () {
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome_fantasia
              })
            })
            this.distribuidores = info
          }
        })
    },
    async getIntegrators (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }

      if (this.$root.Permissions.distributor() && this.revendedor) {
        url = `revendedores/${this.revendedor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getRevendedores (distribuidor = null, cadastro = false) {
      this.loadingRevendedores = true
      let url = 'revendedores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/revendedores`
      }
      await Api.get(url)
        .then(res => {
          var arrayRev = []
          res.data.map(rev => {
            arrayRev.push({
              'text': rev.rev_nome,
              'value': rev.uuid_rev_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.revendedoresCadastro = arrayRev
          }

          if (!cadastro) {
            this.revendedores = arrayRev
          }
          this.loadingRevendedores = false
        })
        .catch(err => {
          this.loadingRevendedores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os revendedores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    searchCep (cep = '') {
      if (cep.length === 8) {
        this.loadingCep = true
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then((response) => {
            if (!response.data.erro) {
              this.contato.cli_rua = response.data.logradouro
              this.contato.cli_bairro = response.data.bairro
              this.contato.cli_complemento = response.data.complemento
              if (response.data.uf) {
                this.contato.cli_uf = response.data.uf
                this.contato.cli_cidade = response.data.localidade
                this.filterCidade(response.data.uf)
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.$root.SnackControl.open(this, {
              text: 'Erro ao buscar por CEP!',
              color: 'error'
            })
          }).finally(() => {
            this.loadingCep = false
          })
      }
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
          if (this.estado) {
            this.cidadesFiltro = this.cidades.filter(city => city.uf === this.estado)
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    openContato (item) {
      this.salvando = true
      this.dialog = true
      Api.get('clientes/' + item.uuid_cli_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          let dados = JSON.parse(JSON.stringify(response.data))
          if (dados.cli_uf) {
            this.filterCidade(response.data.cli_uf)
          }
          if (dados.integrador) {
            dados.uuid_int_id = dados.integrador.uuid_int_id
          }
          if (dados.distribuidor) {
            dados.uuid_dis_id = dados.distribuidor.uuid_dis_id
          }
          this.data = dados.cli_nascimento
          this.contato = dados
        })
        .catch((error) => {
          this.salvando = false
          this.dialog = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro ao carregar dados do contato!',
            color: 'error'
          })
        })
    },
    filterCidade (estado = null) {
      if (!estado) {
        estado = this.estado
        this.cidadesFiltro = this.cidades.filter(city => city.uf === estado)
        this.options.page = 1
        this.applyFilter()
      } else {
        this.cidadesFiltradas = this.cidades.filter(city => city.uf === estado)
      }
    },
    openDialog (item) {
      this.dialog = true
    },
    openDialogDelete (item) {
      this.contato = item
      this.dialogDelete = true
    },
    saveImportar () {
      this.salvando = true
      if (!this.$refs.formImportacao.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      const formData = new FormData()
      formData.append('file', this.importacao)
      formData.append('type', 'contatos')
      Api.post(`dados/importar`, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: response.data.info,
            color: 'success'
          })
          this.closeDialogImportacao()
          if (this.$refs.formImportacao) {
            this.$refs.formImportacao.resetValidation()
          }
          this.getContatos()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeContato () {
      this.salvando = true
      Api.delete(`clientes/remove/${this.contato.uuid_cli_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.salvando = false
          this.dialogDelete = false
          this.getContatos()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover contato!',
            color: 'error'
          })
        })
    },
    closeDialog () {
      this.contato = {
        cli_nome: '',
        cli_tipo: '',
        cli_cpf: '',
        cli_cnpj: '',
        cli_nascimento: '',
        cli_telefone: '',
        cli_celular: '',
        cli_email: '',
        cli_detalhes: '',
        cli_cep: '',
        cli_uf: '',
        cli_cidade: '',
        cli_bairro: '',
        cli_rua: '',
        cli_numero: '',
        cli_complemento: '',
        uuid_int_id: null,
        uuid_dis_id: null
      }
      this.data = ''
      setTimeout(() => {
        this.dataFormatada = ''
        if (this.$refs.formContato) {
          this.$refs.formContato.resetValidation()
        }
      }, 200)
      this.dialog = false
    },
    closeDialogImportacao () {
      this.importacao = ''
      this.dialogImportacao = false
    },
    saveEditContato () {
      if (!this.$refs.formContato.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'clientes/novo'
      let editado = false
      if (this.contato.uuid_cli_id) {
        endpoint = 'clientes/edita'
        editado = true
      }
      if (this.contato.cli_cnpj) {
        this.contato.cli_cnpj = this.contato.cli_cnpj.replaceAll('.', '').replaceAll('/', '').replaceAll('-', '')
      }
      Api.post(endpoint, this.contato)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Contato atualizado com sucesso!' : 'Contato cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getContatos()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    goToContact (item) {
      this.$router.push({ name: 'Contato', params: { uuid: item.uuid_cli_id } }).catch(() => {})
    },
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(this.headerXls),
        busca: this.search,
        distribuidor: this.distribuidor ? this.distribuidor : null,
        integrador: this.integrador ? this.integrador : null,
        estado: this.estado ? this.estado : null,
        cidade: this.cidade ? this.cidade : null,
        type: 'clientes'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader (model) {
      let cabecalhos = []
      model.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      this.removeHeader()
      this.getCidade()
      this.getEstados()
      if (this.$root.Permissions.admin()) {
        this.getDistributors()
      }
      if (!this.$root.Permissions.integrator()) {
        this.getIntegrators(this.distribuidor)
      }
      if (!this.$root.Permissions.revendor()) {
        this.getRevendedores(this.distribuidor)
      }
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.busca) this.search = filters.busca
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.revendedor) this.revendedor = filters.revendedor
      if (filters.estado) this.estado = filters.estado
      if (filters.cidade) this.cidade = filters.cidade
      this.loadFunctions()
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
</style>



// WEBPACK FOOTER //
// src/pages/contatos/Contatos.vue